<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-04 15:35:06
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-05 14:55:23
 * @FilePath: /chaoyongtuan/src/views/settings/tagManage/components/addTag.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog :visible.sync="visible" title="添加标签" width="540px" :before-close="handleClose" :close-on-click-modal="false">
		<el-form :model="form" label-width="80px" class="pt-16">
			<el-form-item label="标签名称" prop="tagName">
				<el-input v-model="form.tagName" placeholder="请输入（10字以内）" maxlength="10" show-word-limit />
			</el-form-item>
		</el-form>
		<div class="footer-dialog" slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="submit" :disabled="isDisabled">确 认</el-button>
		</div>
	</el-dialog>
</template>
<script>
import { saveOrUpdateTag } from '@/api/tagManagement';
export default {
	computed: {
		isDisabled() {
			return !this.form.tagName;
		},
	},
	data() {
		return {
			visible: false,
			form: {
				tagName: '',
			},
		};
	},
	methods: {
		show() {
			this.visible = true;
		},
		async submit() {
			const {
				form: { tagName },
			} = this;
			try {
				await saveOrUpdateTag({ tagsList: [{ tagName: tagName, tagType: 1, appType: 1 }] });
				this.$message.success('操作成功');
				this.$emit('refreshList');
				this.handleClose();
			} catch (err) {}
		},
		handleClose() {
			this.form = {
				tagName: '',
			};
			this.visible = false;
		},
	},
};
</script>
<style lang="scss" scoped></style>
